import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../../../config/routes/routes';
import { PAYMENT_STATUS_PARAM } from '../../../utils/payment/payment.constants';
import { resolvePaymentReturn } from '../../../utils/payment/placedOrder';

// Some payment-provider redirects land on the site root (e.g.
// `/?payment-status=cancel`) instead of the checkout flow, dropping the user
// on the home page. This forwards those into the checkout pages instead.
export const PaymentStatusRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== routes.homepage) {
      return;
    }

    const paymentStatus = new URLSearchParams(location.search).get(
      PAYMENT_STATUS_PARAM,
    );

    if (!paymentStatus) {
      return;
    }

    navigate(resolvePaymentReturn(paymentStatus), { replace: true });
  }, [location, navigate]);

  return null;
};

export default PaymentStatusRedirect;
